module.exports = __webpack_public_path__ + "img/deposit_slip.e9d2a0e4.svg";